import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {setGetSearchList} from '../../store/thunk/setGetSearchList';
import TableCasino from '../../../../../@casino/ui/table';
import Title from '../../../../../@casino/ui/title';
import {columns, getRows} from './helpers';
import makeStyles from '@material-ui/core/styles/makeStyles';
import { setPostUpdateStatus } from '../../store/thunk/setPostUpdateStatus';

const useStyles = makeStyles(() => ({
    root: {
        padding: 20, 
        paddingTop: 0, 
        color: '#fff'
    },
    wrap: {
        padding: 0, 
        background: '#1b2039', 
        borderRadius: 8, 
        marginBottom: 12,
    },
    search: {
        padding: 10,
        background: '#141b33',
        paddingLeft: 10,
        border: '1px solid #141b33',
        color: '#fff',
        outline: 'none',
        margin: 10,
        width: '97.3%'
    },
    wrapBlock: {
        padding: 20, 
        background: '#1b2039', 
        borderRadius: 8, 
        marginBottom: 12,
    }
}))

const SearchGames = () => {
    const classes = useStyles();
    const [desc, setDesc] = React.useState(false);
    const [order, setOrder] = React.useState('uuid');
    const dispatch = useDispatch();
    React.useEffect(() => {
        dispatch(setGetSearchList({
            search: '',
            page: 1,
            rowsPerPage: 25
        }))
    }, [])

    const [search, setSearch] = React.useState('');
    const games = useSelector(state => state.provider.search);

    const rows = React.useMemo(() => getRows(games.data), [games]);
    
    return (
        <div className={classes.root} style={{height: 'calc(100% - 20px)', overflowY: 'scroll'}}>
            <Title label="Поиск по играм" />
            <div className={classes.wrap}>
                <label htmlFor="search">
                    <input 
                        type="text"
                        name="search" 
                        id="search" 
                        value={search} 
                        onChange={(v) => {
                            dispatch(setGetSearchList({
                                search: v.target.value,
                                page: 1,
                                rowsPerPage: 25,
                                order: 'uuid',
                                desc: false
                            }));
                            setSearch(v.target.value)
                        }} 
                        className={classes.search}
                        placeholder="Поиск игр"
                    />
                   
                </label>
            </div>
            <div className={classes.wrapBlock}>
                <TableCasino 
                    updateStatus={(v) => {
                        dispatch(setPostUpdateStatus(v))
                    }}
                    order={(v) => {
                        dispatch(setGetSearchList({
                            search,
                            page: 1,
                            rowsPerPage: 25,
                            order: v.id,
                            desc: !desc
                        }));
                        setDesc(!desc);
                        setOrder(v.id);
                    }}
                    pagination
                    allPage={games.countPage}
                    width={800}
                    perPage={25}
                    columns={columns}
                    rows={rows}
                    changePage={(v) => dispatch(setGetSearchList({
                        search,
                        page: +v.page+1,
                        rowsPerPage: v.rowsPerPage,
                        order,
                        desc

                    }))}
                    changeRowsPerPage={(v) => dispatch(setGetSearchList({
                        search,
                        page: +v.page + 1,
                        rowsPerPage: v.rowsPerPage,
                        order,
                        desc
                    }))}
                />
            </div>
        </div>
    )
}

export default SearchGames;